import { Actions, Button, PasswordField, Stack } from 'braid-design-system';

import { required } from '@seek/validators-js';
import React, { type FormEventHandler } from 'react';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

import type { ErrorMessage } from 'src/types';
import type { DeleteAccountUseField } from './FormContainer';
import CurrentPasswordNotRequired from '../../CurrentPasswordNotRequired/CurrentPasswordNotRequired';
import DontHavePasswordLink from '../../DontHavePassword/DontHavePasswordLinkContainer';
import ServerError from '../../ServerError/ServerError';

interface Props {
  onSubmit: FormEventHandler;
  error?: ErrorMessage;
  toggle: () => void;
  useField: DeleteAccountUseField;
  showCustomerServiceView: boolean;
  submitting: boolean;
}

const Form = ({
  onSubmit,
  error,
  toggle,
  useField,
  showCustomerServiceView,
  submitting,
}: Props) => {
  const { t } = useTranslations(translations);
  const currentPassword = useField({
    id: 'password',
    validators: showCustomerServiceView ? [] : [required],
  });

  return (
    <form onSubmit={onSubmit}>
      <Stack space="xlarge">
        <Stack space="medium">
          {showCustomerServiceView ? (
            <CurrentPasswordNotRequired />
          ) : (
            <Stack space="small">
              <PasswordField
                id="password"
                name="password"
                label={t('Password')}
                {...currentPassword}
              />
              <DontHavePasswordLink originator="delete account" />
            </Stack>
          )}
        </Stack>

        {error && !submitting ? <ServerError error={error} /> : null}
        <Actions>
          <Button type="submit" tone="critical" loading={submitting}>
            {t('Delete account')}
          </Button>
          <Button variant="transparent" tone="formAccent" onClick={toggle}>
            {t('Cancel')}
          </Button>
        </Actions>
      </Stack>
    </form>
  );
};

export default Form;
